import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdAdminService } from 'src/app/admin/ad-admin/ad-admin.service';

export interface SocialLink {
  name: string;
  link: string;
}

@Injectable({ providedIn: 'root' })
export class SocialMediaService {
  private readonly linksSource = new BehaviorSubject<SocialLink[]>([]);
  readonly links$: Observable<SocialLink[]> = this.linksSource.asObservable();

  constructor(private adAdminService: AdAdminService) {}

  refresh(): void {
    this.adAdminService
      .getSocialMediaLinks()
      .pipe(map((data: any) => this.extractSocialMediaLinks(data)))
      .subscribe({
        next: (links) => this.linksSource.next(links),
        error: () => this.linksSource.next([])
      });
  }

  setLinks(links: SocialLink[]): void {
    this.linksSource.next(links || []);
  }

  getCurrentLinks(): SocialLink[] {
    return this.linksSource.value;
  }

  private extractSocialMediaLinks(data: any): SocialLink[] {
    if (!data) { return []; }
    const arr = Array.isArray(data)
      ? data
      : Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data?.data)
          ? data.data
          : [];
    return arr
      .map((x: any) => ({
        name: (x.name || x.platform || x.platform_name || '').toString(),
        link: (x.link || x.url || '').toString()
      }))
      .filter(x => !!x.name && !!x.link);
  }
}


